const STATES_PROVINCES = [
  { group: 'US States', options: [
    'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
    'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
    'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY','DC'
  ]},
  { group: 'Canadian Provinces', options: [
    'AB','BC','MB','NB','NL','NS','NT','NU','ON','PE','QC','SK','YT'
  ]}
];

export default STATES_PROVINCES;
